/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * File: CurrencyInput.tsx
 * Author: Austin Robinson
 * Date Created: 4/29/2022
 * Copyright (c) DrivingDoc 2022
 */
import EditIcon from '@mui/icons-material/Edit';
import Chip from '@mui/material/Chip';

import useAuthContext from 'hooks/useAuthContext';

type PropTypes = {
  calendarEvent: any;
  onclickEmptySeat: any;
  hideFillSeat: boolean | undefined;
};

export default function FillSeat(props: PropTypes) {
  const { calendarEvent, onclickEmptySeat, hideFillSeat } = props;
  const auth = useAuthContext();

  if (auth?.userRole !== 'ADMIN') {
    return <></>;
  }

  if (hideFillSeat) {
    return null;
  }
  return (
    <Chip
      sx={{
        border: '0.2px solid #000000',
        borderRadius: 2,
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        '.MuiChip-avatarSmall': {
          ml: '0px',
          mr: '-4px',
          // width: '22px',
          height: '100%',
          // fontSize: '0.625rem',
        },
        '.MuiChip-clickable&:hover': {
          transform: 'scale(1.05)',
          transition: 'all 400ms cubic-bezier(.56,2.01,.41,.8)',
          backgroundColor: '#FFFFFF',
        },
      }}
      icon={<EditIcon />}
      label="Fill Seat"
      variant="outlined"
      size="small"
      onClick={() => onclickEmptySeat(calendarEvent)}
    />
  );
}
